import { render, staticRenderFns } from "./glitAwardNormination.vue?vue&type=template&id=d553c65c&scoped=true&"
import script from "./glitAwardNormination.vue?vue&type=script&lang=js&"
export * from "./glitAwardNormination.vue?vue&type=script&lang=js&"
import style0 from "./glitAwardNormination.vue?vue&type=style&index=0&id=d553c65c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d553c65c",
  null
  
)

export default component.exports